import { render, staticRenderFns } from "./ReCallsObjMap.vue?vue&type=template&id=23e51bec"
import script from "./ReCallsObjMap.vue?vue&type=script&lang=js"
export * from "./ReCallsObjMap.vue?vue&type=script&lang=js"
import style0 from "./ReCallsObjMap.vue?vue&type=style&index=0&id=23e51bec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports